<template>
  <div>
    <v-container>
      <v-flex xs10 class="mx-auto containerBackground max-width-big">
        <v-container grid-list-xl>
          <v-layout row wrap>
            <v-flex xs12 md12>
              <v-card class="elevation-0 transparent">
                <v-card-text>
                  <v-form ref="form" v-model="valid" lazy-validation>
                    <v-text-field
                      :disabled="statusDisabled"
                      v-model="form.FirstName"
                      :counter="25"
                      :label="this.$translate('REGISTER_FORM_NAME')"
                      autocomplete="name"
                    ></v-text-field>
                    <v-text-field
                      :disabled="statusDisabled"
                      v-model="form.LastName"
                      :counter="25"
                      :label="this.$translate('REGISTER_FORM_LASTNAME')"
                      autocomplete="lastName"
                    ></v-text-field>
                    <v-text-field
                      disabled
                      v-model="form.Email"
                      :rules="emailRules"
                      :label="this.$translate('REGISTER_FORM_EMAIL')"
                      autocomplete="email"
                    ></v-text-field>
                    <v-text-field
                      type="number"
                      v-model="form.PhoneNumber"
                      :counter="15"
                      :label="this.$translate('REGISTER_FORM_PHONE')"
                      autocomplete
                    ></v-text-field>
                    <br>
                    <!-- <v-text-field
                      v-model="form.PostalCode"
                      :label="this.$translate('REGISTER_FORM_ZIP')"
                      autocomplete
                    ></v-text-field>
                    <v-select
                      :items="states"
                      :filter="customFilter"
                      v-model="form.Country"
                      item-text="name"
                      :label="this.$translate('REGISTER_FORM_COUNTRY')"
                    ></v-select>-->
                    <!-- <v-text-field
                      v-model="form.UserRegistrationCode"
                      :label="this.$translate('REGISTER_FORM_VIP')"
                    ></v-text-field>-->
                    <!-- <v-text-field
                      v-model="form.LicensePlate"
                      :label="this.$translate('REGISTER_FORM_LICENSE')"
                      autocomplete
                    ></v-text-field>-->
                    <v-layout row>
                      <h4 class="mt-3 mb-1">{{$translate('INTERESTED_IN')}}</h4>
                      <v-spacer></v-spacer>
                      <v-btn
                        round
                        small
                        color="primary"
                        @click="openUserGroupDialog"
                        class="text-capitalize"
                      >{{$translate('ENTER_SPECIAL_CODE')}}</v-btn>
                    </v-layout>
                    <expendable-tags
                      class="mt-4"
                      :properties="expTagProp"
                      :preselection="preselection"
                      v-on:selectedTags="setSelectedTags"
                      :showOnlySelected="showSelectedUserGroups"
                      :style="`border: 1px solid black;`"
                    ></expendable-tags>

                    <!-- <div v-for="(items, t) in tags" :key="t" v-model="selectedTags">
                      <v-layout class="checkboxLayout">
                        <v-flex xs1>
                          <v-checkbox
                            :disabled="items.Description == 'Administrator'"
                            color="primary"
                            class="checkbox"
                            v-model="checkBoxTags[t]"
                          />
                        </v-flex>
                        <v-flex class="mt-1" xs11>{{items.Description}}</v-flex>
                      </v-layout>
                    </div>-->

                    <v-layout class="checkboxLayout topBorder mt-5"></v-layout>
                    <v-card-text id="infoSmall" class="px-0 changeFont text-md-left text-xs-left">
                      <h3>
                        <v-icon large>info</v-icon>
                        {{$translate('REGISTER_INFO')}}
                      </h3>
                      <p>
                        <b>{{$translate('REGISTER_PHONE')}}</b>
                        {{$translate('REGISTER_PHONE_TEXT')}}
                      </p>
                      <p>
                        <b>{{$translate('REGISTER_ZIPCODE')}}</b>
                        {{$translate('REGISTER_ZIPCODE_TEXT')}}
                      </p>
                      <p>
                        <b>{{$translate('REGISTER_LICENSE')}}</b>
                        {{$translate('REGISTER_LICENSE_TEXT')}}
                      </p>
                    </v-card-text>
                    <!--
                        <v-data-table :headers="headers" :items="userGroups" class="elevation-1 mb-4">
                      <template v-slot:items="props">
                        <td>{{ props.item.userGroupName }}</td>
                     <td>
                          <v-icon small>edit</v-icon>
                          <v-icon small>delete</v-icon>
                        </td>
                      </template>
                      <template v-slot:no-data>
                        <v-btn color="primary" @click="initialize">Reset</v-btn>
                      </template>
                    </v-data-table>-->
                    <v-layout justify-end row>
                      <v-tooltip bottom>
                        <v-btn
                          round
                          class="text-capitalize"
                          slot="activator"
                          @click="goToLogin"
                          color="secondary "
                        >{{$translate('BACK')}}</v-btn>
                        <span>{{$translate('PREVIOUS')}}</span>
                      </v-tooltip>
                      <v-tooltip bottom>
                        <v-btn
                          round
                          class="ml-0 text-capitalize"
                          slot="activator"
                          @click="submit"
                          color="primary"
                        >{{$translate('SAVE')}}</v-btn>

                        <span>{{$translate('SAVE')}}</span>
                      </v-tooltip>
                    </v-layout>
                    <p style="text-align:center">
                      <br>
                    </p>
                    <h3>{{this.errorMsg}}</h3>
                  </v-form>
                </v-card-text>
              </v-card>
            </v-flex>
          </v-layout>

          <v-snackbar
            color="primary"
            :auto-height="true"
            :timeout="timeout"
            :bottom="true"
            :middle="true"
            v-model="snackbar"
          >
            {{this.text}}
            <v-btn flat color="pink" @click.native="snackbar = false">{{$translate('CLOSE')}}</v-btn>
          </v-snackbar>
        </v-container>
      </v-flex>
      <v-dialog v-model="userGroupCodeDialog" max-width="390" persistent>
        <v-card class="dialogVIP">
          <v-card-title class="headline"></v-card-title>
          <v-card-text>
            <h4>{{$translate('LINDA_USERGROUP_DIALOG')}}</h4>
          </v-card-text>
          <v-text-field
            class="ml-3 mr-3"
            :label="$translate('LINDA_VIP_INPUT')"
            placeholder="test group"
            v-model="givenUserGroupCode"
          ></v-text-field>
          <p class="ml-3 errorText" v-if="errorMessageVisible">{{errorMessage}}</p>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn
              round
              class="text-capitalize"
              color="secondary"
              @click="cancelEnteringUserGroupCode"
            >{{$translate('CANCEL')}}</v-btn>
            <v-btn
              round
              class="text-capitalize"
              color="primary"
            >{{$translate('SEND_USERGROUP_CODE')}}</v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
    </v-container>
  </div>
</template>


<script>
import * as dssRequest from "../api/dssRequest";
import UserObject from "../objects/UserObject.js";
import { countries } from "../shared/countries.js";
import { mapGetters } from "vuex";
import { store } from "../store";
import appConfig from "../../config/app_config";
import BaseComponent from "./base/BaseComponent.vue";
import BaseObject from "@/objects/BaseObject";
import ExpendableTags from "@/components/ExpendableTags";

export default {
  extends: BaseComponent,
  name: "UserSettings",
  components: {
    ExpendableTags
  },
  computed: {
    ...mapGetters({
      userGroups: "auth/userGroups"
    })
  },
  data: () => ({
    errorMessageVisible: false,
    errorMessage: "Please provide a valid code or check for usage of capitals",
    givenUserGroupCode: "",
    userGroupCodeDialog: false,
    showSelectedUserGroups: ["UserGroup"],
    inputCodeMode: false,
    headers: [
      {
        text: "User Groups",
        align: "left",
        sortable: true,
        value: "name"
      }
    ],
    request: {
      requestAction: {
        Request: "getChilds",
        ObjectId: "DSSRequestHandler"
      }
    },
    preselection: [],
    expTagProp: {
      disable: false
    },
    statusDisabled: false,
    states: countries,
    customFilter(item, queryText, itemText) {
      const hasValue = val => (val != null ? val : "");
      const text = hasValue(item.name);
      const query = hasValue(queryText);
      return (
        text
          .toString()
          .toLowerCase()
          .indexOf(query.toString().toLowerCase()) > -1
      );
    },
    errorMsg: "",
    visit: {
      myself: false,
      partner: false,
      friends: false,
      kids: false,
      school: false
    },
    form: {},
    tags: [],
    selectedTags: [],
    checkBoxTags: [],
    valid: true,
    name: "",
    status: "",
    text: "",
    snackbar: false,
    timeout: 6000,
    nameRules: [
      v => !!v || "First Name is required",
      v => (v && v.length <= 25) || "Name must be less than 25 characters"
    ],
    lastNameRules: [
      v => !!v || "Last Name is required",
      v => (v && v.length <= 25) || "Name must be less than 25 characters"
    ],
    emailRules: [
      v => !!v || "E-mail is required"
      // v => /^\w+([.-]?\w+)*@\w+([.-]?\w+)*(\.\w{2,3})+$/.test(v) || 'E-mail must be valid'
    ]
  }),
  created() {
    this.user.tags.forEach(t => {
      if (t.TagGroup === "Trial") return;

      if (this.userType == 2 && t.Type == "System") {
        this.tags.push(t);
      } else {
        this.tags.push(t);
      }
    });
    this.tags.forEach((e, i) => {
      if (e.Selected == "yes") {
        this.checkBoxTags.splice(i, 0, e);
      } else {
        this.checkBoxTags.push("");
      }
    });
    this.form = this.user.userData;
    this.cleanUserObject();
    if(this.$store.getters["auth/userName"] != ''){
      this.getUserData();
    }
    if (this.form == undefined) {
      this.form = UserObject._baseObjectDefinition();
    }
  },
  methods: {
    cancelEnteringUserGroupCode() {
      this.givenUserGroupCode = "";
      this.userGroupCodeDialog = false;
    },
    assignUserToUserGroup() {
      if (this.givenUserGroupCode !== "") {
        const payload = {
          UserGroup: this.givenUserGroupCode,
          FunctionId: "TagsFunctionLibrary::assignUserToUserGroup"
        };
        dssRequest.doRequest(
          response => {
            console.log(
              "The generic call assignUserToUserGroup was successful",
              response
            );
            this.userGroupCodeDialog = false;
            this.getUserData();
          },
          error => {
            console.log(
              "The generic call assignUserToUserGroup was not successful",
              error
            );
            let substring = "E_OB_039";
            if (error.data.ErrorMsg.includes(substring)) {
              this.errorMessageVisible = true;
            }
          },
          "communicateWithDBLibrary",
          this.currentAccountId + "_TM",
          payload,
          600000,
          false
        );
      } else {
        this.errorMessageVisible = true;
      }
    },
    getUserData() {
      const payload = {
        RelationType: "User",
        Id: store.getters["auth/userName"],
        Types: {
          User: "User"
        },
        StructuredReply: true
      };
      this.preselection = [];
      dssRequest.doRequest(
        response => {
          console.log("The call for getUserData was successful", response);
          if (response.data.UserData.UserLanguage.LanguageTagId !== undefined) {
            store.commit(
              "setUserLanguage",
              response.data.UserData.UserLanguage.LanguageTagId
            );
          }
          let result = BaseObject._createArrayWithObjects(
            response.data.UserData.User
          );
          this.form = result[0];
          for (let [k, v] of Object.entries(response.data.Tags)) {
            for (let [k1, v1] of Object.entries(v)) {
              if (v1.TagGroup !== "UserGroup" && v1.Selected == "yes") {
                this.preselection.push(v1);
              }
            }
          }
        },
        error => {
          console.log("The call for getUserData was not successful", error);
        },
        "getUserData",
        this.$store.getters["auth/userName"],
        payload
      );
    },
    updateUserGroupList(data) {
      let userGroupData = {};
      for (let i = 0; i < data.length; i++) {
        for (const [key, value] of Object.entries(data)) {
          userGroupData[value.TagId] = value.Description;
        }
      }
      const payload = {
        UserGroup: userGroupData
      };
      dssRequest.doRequest(
        response => {
          console.log("the call updateUserGroupList was succesfull", response);
        },
        error => {
          console.log("the call updateUserGroupList was not succesfull", error);
        },
        "updateUserGroupList",
        this.$store.getters["auth/userName"],
        payload
      );
    },
    openUserGroupDialog() {
      this.givenUserGroupCode = "";
      this.userGroupCodeDialog = true;
    },
    setSelectedTags(data) {
      this.form.tags = data;
    },
    initialize() {},
    cleanUserObject() {
      for (const [k, v] of Object.entries(this.form)) {
        if (v == "NULL") {
          this.form[k] = "";
        }
      }
    },
    goToLogin() {
      this.$router.push({
        name: "Login",
        params: {
          type: "u",
          account_id: store.getters.getRegion
        }
      });
    },
    submit() {
      this.getTagId();
      if (this.$refs.form.validate()) {
        this.form.UserGroup = appConfig.dss.environmentName;
        this.errorMsg = "";
        let payload = UserObject._createEditRequestObject(this.form);
        payload.FunctionId = "UserFunctionLibrary::updateUser";

        dssRequest.doRequest(
          response => {
            console.log(
              "The generic call updateUser was successful",
              response
            );
            this.getUserData();
            this.snackbar = true;
            this.text = this.$translate("SETTINGS_SAVE_OK");
            //find a way to parameterize userType
            new UserObject(this.userName, this.form.Email, "u").getUserData(
              null,
              null
            );
          },
          error => {
            console.log(
              "The generic call updateUser was not successful",
              error
            );
          },
          "communicateWithDBLibrary",
          appConfig.dss.accountManagerObjectId,
          payload
        );
      } else {
      }
    },
    getTagId() {
      const arrayLength = this.tags.length;
      let i = arrayLength;
      this.form.userTags = [];
      while (i--) {
        if (this.checkBoxTags[i] == true) {
          this.form.userTags.push(this.tags[i].TagId);
        } else if (
          this.checkBoxTags[i].hasOwnProperty("Selected") &&
          this.checkBoxTags[i].Selected == "yes"
        ) {
          this.form.userTags.push(this.tags[i].TagId);
        }
      }
    }
  }
};
</script>

<style scoped>
.greyBorder {
  border: 2px solid #c0c0c0 !important;
}

.borderLeft {
  border-left: 2px solid #c0c0c0;
}

@media screen and (max-width: 960px) {
  .borderLeft {
    border-left: 0px;
  }
}

.checkbox {
  margin: 0px !important;
}

.link {
  color: black;
}

.errorText {
  color: red;
}

.checkboxLayout {
  height: 40px !important;
}

.topBorder {
  border-top: 2px solid #c0c0c0;
}

.dialogVIP {
  border-radius: 1em !important;
}

#infoSmall {
  display: none;
}
</style>
